import { apiJS as baseApi } from "@/store/api";

export const TAG_DATA_SOURCE = "DATA_SOURCE";

export type DataSourceParameterValue = string | number | boolean;
export type DataSourceParameter = { name: string; value: DataSourceParameterValue };

export type GetDataSourceOptions = {
    apiVersion: "v2";
    path: string;
    parameters?: Record<string, string | number | boolean>;
};

const api = baseApi
    .enhanceEndpoints({
        addTagTypes: [TAG_DATA_SOURCE],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getDataSource: builder.query<any, GetDataSourceOptions>({
                query: (options) => {
                    const { apiVersion, path, parameters } = options;

                    let url = `data-source/${apiVersion}/${path}`;

                    // Parameters in object
                    if (parameters) {
                        const search = new URLSearchParams();
                        Object.entries(parameters).forEach(([key, value]) => {
                            search.append(key, String(value));
                        });
                        const qs = search.toString();
                        if (qs) url += `?${qs}`;
                    }

                    return {
                        url,
                        method: "GET",
                    };
                },
                providesTags: (_result, _error, arg) => [{ type: TAG_DATA_SOURCE, id: JSON.stringify(arg) }],
            }),
        }),
    });

export { api as dataSourceApi };
export const { useGetDataSourceQuery, useLazyGetDataSourceQuery } = api;
